export default __webpack_public_path__ + "static/social-83b2c807b1914bbed44d941344faf981.jpg";